export const PRESALE_END_DATE =
  import.meta?.env?.VITE_PRESALE_END_DATE || "2026-09-05T23:59:59+05:00";

export const getPresaleTimeLeft = () => {
  const distance = new Date(PRESALE_END_DATE)?.getTime() - Date?.now();

  if (!Number.isFinite(distance) || distance <= 0) {
    return { days: "00", hours: "00", minutes: "00", seconds: "00" };
  }

  return {
    days: String(Math?.floor(distance / 86_400_000)).padStart(2, "0"),
    hours: String(Math?.floor((distance / 3_600_000) % 24)).padStart(2, "0"),
    minutes: String(Math?.floor((distance / 60_000) % 60)).padStart(2, "0"),
    seconds: String(Math?.floor((distance / 1_000) % 60)).padStart(2, "0"),
  };
};

export const hasPresaleCountdownEnded = (timeLeft) =>
  Object?.values(timeLeft)?.every((value) => value === "00");
